import React from 'react';
import * as Icons from 'lucide-react';
import { whyUs } from '../mock';

export default function WhyUs() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-[#0B2545]" />
      <div className="absolute inset-0 opacity-[0.06] bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1526481280693-3bfa7568e0f3?crop=entropy&cs=srgb&fm=jpg&q=60&w=1600')" }} />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-14 reveal">
          <p className="section-eyebrow mb-3 text-[#ff9a6a]"><span className="h-px w-8 bg-[#EA5019] inline-block" /> WHY TRAVEL ERA HOLIDAY</p>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white leading-tight">Travel With Confidence.</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyUs.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Star;
            return (
              <div
                key={w.title}
                className="reveal p-7 rounded-2xl bg-white/[0.06] border border-white/10 backdrop-blur-sm hover:bg-white/[0.1] hover:-translate-y-1.5 transition-all duration-300"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <span className="grid place-items-center h-14 w-14 rounded-xl bg-[#EA5019] text-white mb-5">
                  <Icon size={26} />
                </span>
                <h3 className="font-heading text-lg font-bold text-white mb-2">{w.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
